import { HttpAgent, HttpAgentOptions } from '@icp-sdk/core/agent'
import type { IWalletKit } from '@reown/walletkit'
import { IStorage } from './interfaces/storage'
import { WalletAction } from './interfaces/walletActions'

export type AppConfig = {
  fetchEnv: (key: string) => string
  getAgent: (options?: HttpAgentOptions & { principalId?: string }) => HttpAgent
  callWallet: (action: WalletAction, wallet: string, payload?: unknown) => Promise<unknown>
  localStorage: IStorage
  sessionStorage: IStorage
  walletKit?: IWalletKit
}

// @ts-ignore
export const config: AppConfig = {}

export const setConfig = <K extends keyof AppConfig>(property: K, value: AppConfig[K]) => {
  config[property] = value
}
